import axios from 'axios';

import { identifyChargeblast } from 'core/utils/chargeblast';

/**
 * Chargeblast identify for the emails entered outside the payment form.
 *
 * Every email a user commits in a funnel reaches the backend on the APP's axios:
 * `POST /v2/user` (email screens and popups) or `PUT /user/update-by-token/:id`
 * (paywall success with a wallet email, email-after-payment in the deferred-email
 * flow). Every Stripe charge sends its own /track from core/store/billing/actions.ts
 * (subscribe, createOneClickPayment). Hooking the two requests covers every funnel without touching
 * its screens, and keystrokes never get here. Fires only after the backend accepted
 * the request; a no-op unless the flow pays through Stripe (core/utils/chargeblast.ts).
 *
 * Runs as a side effect on import from `src/index.tsx`.
 */
const USER_EMAIL_PATH = /\/v2\/user$|\/user\/update-by-token\/[^/]+$/;

const readEmail = (data: unknown): unknown => {
  const body = typeof data === 'string' ? JSON.parse(data) : data;
  return body && typeof body === 'object' ? (body as { email?: unknown }).email : undefined;
};

axios.interceptors.response.use((response) => {
  try {
    const { method, url = '', data } = response.config;
    const path = url.split(/[?#]/)[0].replace(/\/+$/, '');
    if ((method === 'post' || method === 'put') && USER_EMAIL_PATH.test(path)) {
      identifyChargeblast(readEmail(data));
    }
  } catch (e) {
    // an unreadable body is simply not sent to Chargeblast
  }
  return response;
});
